export const normalizeHtmlText = (text = '') => {
  if (!text || typeof text !== 'string') {
    return '';
  }

  return (
    text
      // saltos reales
      .replace(/\r\n|\r/g, '\n')
      .replace(/\\n/g, '\n')

      // entidades básicas
      .replace(/&lt;/gi, '<')
      .replace(/&gt;/gi, '>')
      .replace(/&nbsp;/gi, ' ')
      .replace(/&amp;/gi, '&')
      .replace(/&#039;/g, "'")
      .replace(/&quot;/g, '"')

      // FIX proveedor: &<ul&> / &</li&>
      .replace(/&<\s*/g, '<')
      .replace(/\s*&>/g, '>')
      .replace(/&<\/\s*/g, '</')

      // FIX espacios dentro tags
      .replace(/<\s+([a-z/])/gi, '<$1')
      .replace(/([a-z])\s+>/gi, '$1>')

      // FIX comas pegadas a tags
      .replace(/<\/(ul|li|p|br|div|span|h[1-6])>\s*,\s*/gi, '</$1>')

      // frases pegadas (tu lógica original)
      .replace(/([.!?])([A-Z])/g, '$1 $2')

      // puntos repetidos
      .replace(/\.{2,}/g, '.')

      // br normalización
      .replace(/<br\s*\/?>/gi, '<br />')

      // espacios
      .replace(/[ \t]+\n/g, '\n')
      .replace(/\n[ \t]+/g, '\n')

      // párrafos
      .replace(/\n{2,}/g, '<br /><br />')
      .replace(/\n/g, '<br />')

      // exceso de br
      .replace(/(<br\s*\/?>){3,}/gi, '<br /><br />')

      // limpieza final
      .replace(/[ \t]{2,}/g, ' ')
      .trim()
  );
};
